import classNames from 'classnames'
import { TFitterProfileResponse, UserMainPage } from 'feature/user/types'
import { formatPhoneNumber } from 'helpers/phones'

import style from './UserData.module.scss'

type UserDataProps = {
  className?: string
  data: UserMainPage | TFitterProfileResponse
}
// личная инфомация пользователя на странице настроек
export function UserData({ className, data }: UserDataProps) {
  return (
    <section className={classNames(style['user-data'], className)}>
      <span className={style['user-data__name']}>{data.firstName}</span>
      <span className={style['user-data__lastNames']}>{data.lastName}</span>
      <span className={style['user-data__phone']}>
        {formatPhoneNumber(data.phone)}
      </span>
    </section>
  )
}
